import React, { useEffect } from 'react'
import Logo from '../../img/logo2.svg'
import classes from './ThankYou.module.css';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ThankYou = (props) => {

  const { lang } = useParams();
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);

  return (
    <React.Fragment>
        <main className={classes.thankYouPage}>
          <div className={classes.logo}>
            <Link to="/"  title="Link do strony głównej" className={classes.logo__link}>
              <img src={Logo} alt="Indigo Nails" title="Logo Indigo Nails" className={classes.header__logo}/>
            </Link>
          </div>
          <div className={classes.thankYou}>
            <div className={classes.thankYou__information}>
              <h1 className={classes.thankYou__header}>
                {props.onTranslate('thank_you')}
              </h1>
            </div>
          </div>            
        </main>
    </React.Fragment>
  )
}

export default ThankYou;